export default __webpack_public_path__ + "static/media/03.2dd33f5f.jpg";